// src/shared/components/BurgerMenu/BurgerMenu.tsx

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { motion } from 'framer-motion';
import styles from './BurgerMenu.module.scss';

const BurgerMenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isMenuPage = location.pathname === '/menu';

  const handleMenuClick = () => {
    if (isMenuPage) {
      navigate(-1);
    } else {
      navigate('/menu');
    }
  };

  return (
    <motion.button
      className={styles.burgerMenu}
      onClick={handleMenuClick}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
    >
      {isMenuPage ? <FiX /> : <FiMenu />}
    </motion.button>
  );
};

export default BurgerMenu;